import script from "./TypeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeSelector.vue?vue&type=script&setup=true&lang=js"

import "./TypeSelector.vue?vue&type=style&index=0&id=749526ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-749526ec"]])

export default __exports__